import ValidService from "../../../../service/ValidService"

export default {
  dataForm : {
    "name": undefined, // required - Tên văn bản
    "code": null, // required, maxLength: 50 - Mã
    "effected_date": undefined, // optional - Ngày hiệu lực
    "company_id": undefined, // optional, ref: company - Mã công ty
    "dda_category_id": undefined, // required, ref: text_category - Loại văn bản
    "dda_template_id": undefined, // required, ref: text_template - Loại mẫu văn bản
    "html": undefined, // required - HTML content
    "unsigned_pdf_id": undefined, // optional, ref: mushroom_file - Id file pdf chưa ký
    "signed_pdf_id": undefined, // optional, ref: mushroom_file - Id file pdf đã ký
    "status": undefined, // required, enum(DRAFF, COMPLETED)
    "creator_id": undefined, // required, ref: mushroom_user - Người tạo
    "created_at": undefined, // required - Thời điểm tạo
    "updated_at": undefined, // required - Thời điểm cập nhật
    "disabled": undefined, // required - Đã bị khóa chưa
    "dda_template_name": undefined,
    "dda_category_name": undefined,
    'readers': []
  },
  validForm: {
    name: [ValidService.required, ValidService.checkMaxLength(200)],
    code: [ValidService.required, ValidService.checkMaxLength(50), ValidService.checkSpaceStringCenter],
    dda_template_id: [ValidService.requiredChange],
  },
  tableRules: {
    data: [],
    lengthMenu: [20, 40, 80, 120, 200, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 20,
    offset: 0,
    sort: "-created_at",
    defaultSort: ['created_at', 'descending'],
    filters: "",
    recordSelected: [],
    dataSearch: {
      value: {
        "name_code": '',
        "dda_category_id": '',
        "created_at": '',
      },
      valid: {},
      operator: {
        "name_code": '$vn_text=',
        "dda_category_id": '',
        "created_at": ':in_that_day:',
      },
      dataFind: {
        "from_date": '',
        "to_date": '',
      }
    }
  }
}
